import { inject, Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  EFahrgasttyp,
  IOnDemandExtraForm,
  IOnDemandPassengerOptionsForm,
  TariffSelectionAttributeValue,
} from '@web/dtos';

@Injectable({ providedIn: 'root' })
export class OnDemandOptionsFormService {
  private readonly fb = inject(FormBuilder);

  buildPassengerOptionsForm(
    initialSelectionAttributes: TariffSelectionAttributeValue[] = []
  ): FormGroup<IOnDemandPassengerOptionsForm> {
    return this.fb.group<IOnDemandPassengerOptionsForm>({
      fahrgasttyp: this.fb.nonNullable.control<string>(EFahrgasttyp.ERWACHSENER, Validators.required),
      selectionAttributes: this.fb.nonNullable.array<
        FormControl<TariffSelectionAttributeValue>
      >(
        initialSelectionAttributes.map(val =>
          this.fb.nonNullable.control(val, Validators.required)
        )
      ),
      useExistingTicket: this.fb.nonNullable.control(false),
      existingTicketType: this.fb.control<string | null>(null),
      selectedExtras: this.fb.array<FormGroup<IOnDemandExtraForm>>([]),
    });
  }

  addExtra(
    form: FormGroup<IOnDemandPassengerOptionsForm>,
    serviceId = '',
    name = ''
  ): void {
    form.controls.selectedExtras.push(this.buildExtraForm(serviceId, name));
  }

  removeExtra(
    form: FormGroup<IOnDemandPassengerOptionsForm>,
    index: number
  ): void {
    form.controls.selectedExtras.removeAt(index);
    form.controls.selectedExtras.updateValueAndValidity();
  }

  private buildExtraForm(
    serviceId: string,
    name: string
  ): FormGroup<IOnDemandExtraForm> {
    return this.fb.group<IOnDemandExtraForm>({
      publicTransportXml: this.fb.nonNullable.control(serviceId, Validators.required),
      name: this.fb.nonNullable.control(name),
    });
  }
}
